/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import fileIcon from '../../static/images/fileIcon.svg';

const GenerateAndDownloadSampleFile = props => {
    const {
        actions,
    } = props;

    const handleOpenActionPopup = () => {
        const payload = {
            s3Path: "/kycDocFile/draftmerchant/null/1758001957675/SampleFile.xlsx",
        };
        actions.generateAndDownloadSampleFileRequest(payload);
    };

    return (
        <div className="download-popup">
            <button
                className="custom-btn-2"
                id="bulk-upload-btn"
                type="button"
                onClick={handleOpenActionPopup}
            >
                <img src={fileIcon} alt="Upload" width={18} height={14} />
                Generate & Download Sample File
            </button>
        </div>
    );
};

GenerateAndDownloadSampleFile.propTypes = {
    actions: PropTypes.object,
};

export default reduxForm({
    form: 'downloadFile',
    enableReinitialize: true,
    destroyOnUnmount: false,
})(GenerateAndDownloadSampleFile);